module.exports = __webpack_public_path__ + "img/the-netherlands-congenital-and-perinatal-diseases-male.f79a862d.png";